import React from 'react';
import { Box} from '@mui/material';
import { Container } from '@mui/material';

import UpdateBuilderAgencyForm from '../Components/UpdateBuilderAgencyForm'

export default function UpdateBuilderAgencyPage() {
  return (
    <Box>
      <Container>
        <UpdateBuilderAgencyForm/>
      </Container>
    </Box>
  )
}
